// src/config/env-status.ts
//
// Defensive MIRROR of the ems-api CANONICAL env-status contract
// (EnvPublicPowerStatus / EnvPublicStatusDto / EnvStatusArtifact in
// ems-api `src/types/env-power.types.ts`). Parsed defensively and fail-open, so a
// backend shape change degrades gracefully here — keep this in sync with the canonical.
//
// This site (ai2aim.ai) calls the EMS API. When a non-prod EMS environment is parked by
// env-power, this lets the matching build render the "environment paused" screen instead
// of failing against a stopped API.

export type EnvPublicStatus = "on" | "paused" | "starting";

export interface EnvStatusEntry {
  environment: string;
  label: string;
  status: EnvPublicStatus;
  /** ISO8601 next scheduled on-time, or null (already on / no auto-schedule). */
  nextOnAt: string | null;
  /** IANA timezone nextOnAt is expressed in. */
  timezone: string;
}

export interface EnvStatusArtifact {
  environments?: EnvStatusEntry[];
  updatedAt?: string;
}

/** The status-artifact URL (env-status.json on the status CDN); unset ⇒ gate inert. */
export const ENV_STATUS_URL = import.meta.env.VITE_ENV_STATUS_URL;

/**
 * Which parkable EMS environment this build targets, or null when it is never parked.
 * Derived from VITE_OBS_ENV (the `main` build = "staging", the `prod` build =
 * "production"). Only dev/staging are controllable by env-power; production is never
 * parked, so it stays inert.
 */
export function currentEnvSlug(): "dev" | "staging" | null {
  const env = import.meta.env.VITE_OBS_ENV;
  if (env === "staging") return "staging";
  if (env === "dev" || env === "development") return "dev";
  return null;
}
